import { render } from "./tjFileUploader.vue?vue&type=template&id=05ba070a&scoped=true"
import script from "./tjFileUploader.vue?vue&type=script&lang=js"
export * from "./tjFileUploader.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ba070a"]])

export default __exports__